import { httpInstance } from '@/services/httpInstance';

const putCreditCardConfig = async (body) => {
  const endpoint = '/back-office/v1/credit-card-config';
  let res;
  await httpInstance.put(
    endpoint,
    body,
  ).then((dataResponse) => {
    res = dataResponse;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default putCreditCardConfig;
